module.exports = __webpack_public_path__ + "img/img17.eb3cc681.png";